import Image from "next/image";
import Link from "next/link";

import type { WhyChooseComparison } from "@/content/alternatives/schema";

interface WhyChooseReboltProps {
  heading: string;
  comparisons: WhyChooseComparison[];
}

export function WhyChooseRebolt({ heading, comparisons }: WhyChooseReboltProps) {
  const headingParts = heading.split("Rebolt");

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
            {headingParts.length > 1 ? (
              <>
                {headingParts[0]}
                <span className="text-rebolt-500">Rebolt</span>
                {headingParts[1]}
              </>
            ) : (
              heading
            )}
          </h2>
        </div>

        <div className="mt-14 space-y-20">
          {comparisons.map((comparison, i) => {
            const isImageRight = i % 2 === 0;
            return (
              <div
                key={comparison.title}
                className={`flex flex-col items-center gap-10 lg:flex-row ${isImageRight ? "" : "lg:flex-row-reverse"}`}
              >
                <div className="flex-1 space-y-4">
                  <h3 className="font-clash text-xl font-medium leading-tight tracking-[-0.01em] text-ash-900 md:text-2xl">
                    {comparison.title}
                  </h3>
                  <p className="text-base leading-relaxed text-ash-500 md:text-lg">{comparison.description}</p>
                  <p className="text-base text-ash-600">
                    <strong className="text-ash-900">Winner: </strong>
                    <strong className="text-rebolt-500">Rebolt</strong>
                    <span> – {comparison.winnerNote}</span>
                  </p>
                </div>

                {comparison.image && (
                  <div className="w-full flex-1 lg:max-w-md">
                    <div className="overflow-hidden rounded-2xl border border-ash-200">
                      <Image
                        src={comparison.image.src}
                        alt={comparison.image.alt}
                        width={800}
                        height={600}
                        className="h-auto w-full"
                      />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex justify-center">
          <Link
            href="https://cal.com/team/builtright/launch"
            className="inline-flex items-center rounded-full bg-rebolt-500 px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-rebolt-600"
          >
            Try Rebolt
          </Link>
        </div>
      </div>
    </section>
  );
}
